import React from 'react';

import './inputOutlet.style.scss';
interface IInputOutletProps extends React.HTMLProps<HTMLInputElement> {
  label: string;
  labelFloatClassname?: string;
  secondaryTitle?: React.ReactNode;
  required?: boolean;
  errors?: string;
  name: string;
  touched?: boolean;
  leftAdornment?: React.ReactNode;
  showStar?: boolean;
}

const InputOutlet = ({
  label,
  labelFloatClassname,
  required = false,
  errors,
  touched,
  name,
  secondaryTitle,
  leftAdornment,
  showStar = true,
  ...props
}: IInputOutletProps) => {
  return (
    <div
      className={`
        ${
          name === 'code'
            ? 'floating-green-label-input floating-label-input'
            : ' floating-label-input relative'
        }
      ${props.disabled && ' bg-gray-50'}`}
    >
      {leftAdornment && (
        <div className="absolute left-0 inset-y-0 flex items-center pl-3 text-sm text-gray-500 pointer-events-none   top-0.5 h-12 ">
          {leftAdornment}
        </div>
      )}
      <input
        type={props.type}
        id={name}
        name={name}
        {...props}
        className={
          (touched && errors && !props.disabled ? 'invalid ' : '') +
          (touched && !errors && !props.disabled ? 'valid ' : '') +
          (leftAdornment ? 'with-left-adornment' : '') +
          (props.disabled && 'disabled-input')
        }
      />
      <label
        htmlFor={name}
        className={`bg-white ${props.disabled && 'text-gray-500'}`}
      >
        {label}
        {required && label && showStar && (
          <span className=" text-red-400 required-star"> * </span>
        )}
      </label>
      {secondaryTitle && (
        <span className="secondary-title">{secondaryTitle}</span>
      )}
      {touched && errors && !props.disabled && (
        <>
          <div className="pt-1">
            <small>
              <i className="icon-warning"></i> {errors}
            </small>
          </div>
          {!secondaryTitle && (
            <span className="input-icon invalid">
              <i className="icon-error-field"></i>
            </span>
          )}
        </>
      )}

      {touched && !errors && !props.disabled && !secondaryTitle && (
        <span className="input-icon valid">
          <i className="icon-success-field"></i>
        </span>
      )}
    </div>
  );
};
export default InputOutlet;
